import { gql } from 'apollo-angular';

export const GET_CART = gql`
  query cart($id: ID!) {
    cart(id: $id) {
      id
      createdAt
      updatedAt
      checkoutUrl
      lines(first: 250) {
        edges {
          node {
            id
            quantity
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
              }
              remainingBalanceChargeAmount {
                amount
              }
              sellingPlan {
                id
                name
                options {
                  name
                  value
                }
              }
              priceAdjustments {
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                perDeliveryPrice {
                  amount
                  currencyCode
                }
                unitPrice {
                  amount
                  currencyCode
                }
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                quantityAvailable
                sku
                title
                price {
                  amount
                }
                product {
                  title
                }
                sellingPlanAllocations(first:3) {
                  edges {
                    node {
                      sellingPlan {
                        id
                        name
                        options {
                          name
                          value
                        }
                      }
                      priceAdjustments {
                        price {
                          amount
                          currencyCode
                        }
                        compareAtPrice {
                          amount
                          currencyCode
                        }
                        perDeliveryPrice {
                          amount
                          currencyCode
                        }
                        unitPrice {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                }
                weight
                weightUnit
                image {
                  url(transform: { maxHeight: 2000, maxWidth: 2000 })
                  altText
                  width
                  height
                  id
                }
              }
            }
          }
        }
      }
      attributes {
        key
        value
      }
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
      }
    }
  }
`

export const CREATE_CART = gql`
  mutation cartCreate($cartInput: CartInput) {
    cartCreate(input: $cartInput) {
      cart {
        id
        createdAt
        updatedAt
        lines(first: 250) {
          edges {
            node {
              id
              merchandise {
                ... on ProductVariant {
                  id
                }
              }
              sellingPlanAllocation {
                checkoutChargeAmount {
                  amount
                }
                remainingBalanceChargeAmount {
                  amount
                }
                sellingPlan {
                  id
                  name
                  options {
                    name
                    value
                  }
                }
                priceAdjustments {
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  perDeliveryPrice {
                    amount
                    currencyCode
                  }
                  unitPrice {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
        attributes {
          key
          value
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export const GET_CHECKOUT_URL = gql`
  query cartCheckoutUrl($id: ID!) {
    cart(id: $id) {
      checkoutUrl
    }
  }
`